module.exports = __webpack_public_path__ + "img/info.8a6c12a9.svg";